import React from "react";
import { SecurityLayout } from "security-app/components/Layout";
import Router from "security-app/routing/Router";
const SecurityPage = () => /* @__PURE__ */ React.createElement(SecurityLayout, null, /* @__PURE__ */ React.createElement(Router, null));
export default SecurityPage;
